module.exports = __webpack_public_path__ + "img/index1.a31fe7cb.png";